module.exports = __webpack_public_path__ + "bg-2.8790df5b2086b6d0ecc5.jpg";


//////////////////
// WEBPACK FOOTER
// D:/sachin/umc-new/umc/src/assets/images/bg-2.jpg
// module id = ../../../../../src/assets/images/bg-2.jpg
// module chunks = styles